import { Component, OnInit, OnDestroy } from '@angular/core';
import { ItemStatsService } from '../../services/service.index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/authorization/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: []
})

export class HomeComponent implements OnInit, OnDestroy {

  signalsTotal: string;
  tradingTotal: string;
  marketingTotal: string;
  educationTotal: string;
  private unsubscribe$ = new Subject<void>();


  dataset: any = {
    chart1: {
      months: this.xAxisLabels(),
      data: [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Users' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Items' }
      ]
    }
  };

  dataset2: any = {
    chart1: {
      labels: [['Leidas'], ['Sin Leer'], ['Sin enviar']],
      data: [[300, 500, 100]]
    }
  };

  constructor(private auth: AuthService, private itemStatsService: ItemStatsService) { }

  ngOnInit() {
    // this.awake();
    // this.getItemStats();
    // this.getUserStats();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  // awake() {
  //   this.adminService.wakeUp().subscribe((res: any) => {
  //     console.log(res);
  //   });
  // }

  getItemStats() {
    this.itemStatsService.getItemStats()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        const resbody = res.body;
        const data = JSON.parse(resbody).data;
        // Boxes
        this.signalsTotal = data.subtotals.signal.toString();
        this.tradingTotal = data.subtotals.trading.toString();
        this.educationTotal = data.subtotals.education.toString();
        this.marketingTotal = data.subtotals.marketing.toString();
        // Pie Chart
        this.dataset2.chart1.label = [];
        this.dataset2.chart1.labels = Object.keys(data.subtotals).map(category => {
          return [category];
        });
        this.dataset2.chart1.data = [];
        const chart2data = Object.keys(data.subtotals).map(category => {
          return data.subtotals[category];
        });
        this.dataset2.chart1.data = [chart2data];
        // Bar chart
        let i = 0;
        this.dataset.chart1.months.forEach((month: string) => {
          let count = 0;
          if (data.MonthlyTotal.hasOwnProperty(month)) {
            count = data.MonthlyTotal[month];
          };
          this.dataset.chart1.data[1].data[i] = count;
          i += 1;
        });
      }, error => {
        // console.log(error.status);
        if (error.status === 0 || error.status === 401) {
          // console.log('entro');
          //this.auth.cognitoUtil.refreshToken();
          this.getItemStats();
        }
      });
  }

  getUserStats() {
    this.itemStatsService.getUserStats()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        const resbody = res.body;
        const data = JSON.parse(resbody);
        let i = 0;
        this.dataset.chart1.months.forEach((month: string) => {
          let count = 0;
          if (data.Total.hasOwnProperty(month)) {
            count = data.Total[month];
          };
          this.dataset.chart1.data[0].data[i] = count;
          i += 1;
        });
      }, error => {
        // console.log(error.status);
        if (error.status === 0 || error.status === 401) {
          // console.log('entro');
          //this.auth.cognitoUtil.refreshToken();
          this.getUserStats();
        }
      });
  }

  xAxisLabels() {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const today: Date = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let result: any[] = [];
    result = result;
    for (let i = 0; i <= 11; i++) {
      result.push(months[month] + '-' + year);
      if (month - 1 < 0) {
        month = 12 + month - 1;
        year = year - 1;
      } else {
        month = month - 1;
      }
    }
    return result.reverse();
  }
}
